module.exports = __webpack_public_path__ + "2b17372fb017e7711714132d550d7693.svg";